import { render, staticRenderFns } from "./ServicoProfile.vue?vue&type=template&id=bc38d3f6"
import script from "./ServicoProfile.vue?vue&type=script&lang=js"
export * from "./ServicoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports